import { BrandingSchema } from '@kilat/shared';
import { createRepo } from './_base.js';

/**
 * tenants/{tid}/branding/current — per-tenant branding doc for the white-label customer PWA.
 *
 * This factory takes a tenant id at call time because Firestore paths must be
 * statically known per repo instance. Use brandingRepoFor(tid).get('current').
 */
export function brandingRepoFor(tenantId: string) {
  return createRepo({
    path: `tenants/${tenantId}/branding`,
    schema: BrandingSchema,
    name: `tenants/${tenantId}/branding`,
  });
}
